export const capitalizeEachWord = str => {
    let result = ''
    let parts = str.trim().split(' ')
    parts.forEach(word => {
        result += (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ')
    })
    return result.trim()
}